export const infiniteScroll = {
  mounted: async function () {
  // Detect when scrolled to bottom.
    window.addEventListener('scroll', this.scrollEvent)
  },
  beforeDestroy: async function () {
    window.removeEventListener('scroll', this.scrollEvent)
  },
  methods: {
    scrollEvent: function (event) {
      const htmlElement = document.querySelector('html')
      if (htmlElement.scrollTop + htmlElement.clientHeight >= htmlElement.scrollHeight - 300) {
        this.infiniteHandler()
      }
    }
  }
}
